import React, { Suspense, useEffect, useState, useLayoutEffect } from "react";
import { Helmet } from "react-helmet";
import HomeBanner from "../HomeBanner/HomeBanner";
import { useDispatch, useSelector } from "react-redux";
import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import Shimmer from "../../components/Shimmer";
import { saveFullPageLoading } from "../../features/FullPageLoading/FullPageLoadingSlice";
import { useLazyQuery } from "@apollo/client";
import { GET_RECENTLY_VIEWED_LIST } from "../../Pregrine/RecentlyViewedPage/RecentyViewed.gql";

const RecentlyViewedSection = React.lazy(() =>
  import("../../components/RecentlyViewedSection/RecentlyViewedSection")
);

const CategoriesInFocus = React.lazy(() =>
  import("../CategoriesInFocus/CategoriesInFocus")
);

const TopProducts = React.lazy(() => import("../TopProducts/TopProducts"));
const HomeBlogsListing = React.lazy(() =>
  import("../HomeBlogsListing/HomeBlogsListing")
);
const DiscoverOurServices = React.lazy(() =>
  import("../DiscoverOurServices/DiscoverOurServices")
);
const InspirationZone = React.lazy(() =>
  import("../InspirationZone/InspirationZone")
);

const CompareWidget = React.lazy(() =>
  import("../../components/CompareWidget/CompareWidget")
);

const Testimonals = React.lazy(() => import("../Testimonals/Testimonals"));

const HomePage = () => {
  const [isScrolledDown, setIsScrolledDown] = useState(false);
  const recentlyViewedData = useSelector((state) => state.recentlyViewed);
  const [getRecentlyViewedList, { data }] = useLazyQuery(
    GET_RECENTLY_VIEWED_LIST
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveMegaMenu(true));
  }, []);

  const handleScroll = () => {
    const scrolledDown = window.scrollY > 0;
    setIsScrolledDown(scrolledDown);
    if (!recentlyViewedData.length) return;
    getRecentlyViewedList({
      variables: { productSkus: recentlyViewedData?.map((item) => item.sku) },
      skip: !recentlyViewedData.length,
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const existingMetaDescription = document.querySelector(
      'meta[name="description"]'
    );
    if (existingMetaDescription) {
      existingMetaDescription.remove();
    }
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    dispatch(saveFullPageLoading(true));
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Hettich Fitings online | Hettich India Pvt. Ltd.</title>
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Buy Hettich Fitings online | Hettich India Pvt. Ltd."
        />
        <link rel="canonical" href={`${document.location.origin}`} />
      </Helmet>
      <HomeBanner />
      <Suspense fallback={null}>
        <CategoriesInFocus />
      </Suspense>
      <div>
        {isScrolledDown ? (
          <>
            <Suspense fallback={null}>
              <InspirationZone />
            </Suspense>
            <Suspense fallback={null}>
              <TopProducts />
            </Suspense>

            <Suspense fallback={null}>
              <RecentlyViewedSection products={data?.products?.items || []} />
            </Suspense>

            <Suspense fallback={null}>
              <DiscoverOurServices />
            </Suspense>
            <Suspense fallback={<Shimmer width={"100%"} height="200px" />}>
              <Testimonals />
            </Suspense>
            <Suspense fallback={null}>
              <HomeBlogsListing />
            </Suspense>

            <Suspense fallback={null}>
              <CompareWidget />
            </Suspense>
          </>
        ) : null}
      </div>
    </>
  );
};

export default HomePage;
